import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { selfieCopy } from '@/Pages/Selfie/copy';
import '@/Pages/Selfie/SelfiePage.sass';

type SelfieValidationProgressProps = {
  progress: number;
};

export function SelfieValidationProgress({
  progress,
}: SelfieValidationProgressProps): JSX.Element {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <Box
      className="selfie-validation-progress"
      data-testid="selfie-validation-progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clampedProgress}
      aria-label={selfieCopy.validationStatus}
    >
      <Box className="selfie-validation-progress__track">
        <Box
          className="selfie-validation-progress__bar"
          style={{ width: `${clampedProgress}%` }}
        />
      </Box>
      <Typography component="p" className="selfie-validation-progress__status">
        {selfieCopy.validationStatus}
      </Typography>
    </Box>
  );
}
